// Profile of Nikolai Genov, Bulgarian. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • Здравеопазване, науки за живота, финанси',
  summary: 'Доктор по биоинформатика и практически ангажиран технически ръководител, който съчетава софтуерна разработка с помощта на ИИ с анализи в регулираните сектори здравеопазване, науки за живота и финанси. Експертизата обхваща LLM/RAG системи, MCP интеграция, клинични данни, петгодишни банкови прогнози и автоматизирана Excel отчетност. Съчетава разработка на R/Python с координация на екип, осигуряване на качеството и уъркшопи на ниво висше ръководство; сертифициран по AI Act и обучен по GCP.',
  imageAlt: 'Портрет на Nikolai Genov',
  personal: {
    position: 'Съосновател и управител на pAIoneer Labs GmbH, управител на Leap Dynamics GmbH',
    location: 'Берлин, Германия',
    languages: 'Немски и английски (свободно), български (свободно)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'Сертификат по AI Act, обучение по GCP (2025)',
    publications: 'Рецензирани научни трудове в Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology и PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Докторантура: биоинформатика / теоретична биология',
      institution: '',
      degree: 'Степен: доктор (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Обучение: биоинформатика',
      institution: 'Freie Universität Berlin',
      degree: 'Степен: M.Sc. по биоинформатика'
    },
    {
      period: '2012',
      field: 'Обучение: биоинформатика',
      institution: 'Freie Universität Berlin',
      degree: 'Степен: B.Sc. по биоинформатика'
    }
  ],
  skills: [
    {
      title: 'Основни компетенции',
      description: 'Разработка с помощта на ИИ, R/Python, LLM/RAG и MCP, клинични данни и биоинформатика, прогнозиране и стрес тестове, Excel отчетност, Shiny, техническо ръководство'
    },
    {
      title: 'Програмиране и анализи',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Приложения и отчетност',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; автоматизирана отчетност в Excel/Word/PDF'
    },
    {
      title: 'ИИ и интеграция',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; разработка с помощта на ИИ с човешка проверка'
    },
    {
      title: 'Инженеринг',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Биоинформатика',
      description: 'RNA-seq, микрочипове, алтернативен сплайсинг/изоформи, анализ на обогатяването на генни набори, анализ на сигнални пътища и мрежи, асемблиране на геноми, анализ на преживяемостта; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Клинични данни',
      description: 'EDC, CRF, автоматични проверки на данните (edit checks), DMP, планове за валидиране на данни, UAT, съгласуване на SAE; CDISC SDTM/ADaM, RAW/SDTM/ADaM пайплайни, QC'
    }
  ],
  positions: [
    {
      period: '2022 - април 2024',
      title: 'Автоматизация на отчетността, T-Systems / Европейска централна банка (ЕЦБ)',
      description: [
        'Разработка на R библиотека за статистическа отчетност върху финансови времеви редове; миграция на FAME логика към R/Python с Reticulate и автоматизирано генериране на Word/PDF документи.',
        'Разработка на пайплайни за автоматизирано генериране на Excel отчети; интегриране на анализите с Camunda и поддръжка на GitLab CI/CD, модулни тестове, линтинг, SonarQube и документация.',
        'Заместване на ръководителя на екипа и участие в планирането на спринтове, техническата координация, осигуряването на качеството и работата със заинтересованите страни.'
      ]
    },
    {
      period: 'юни 2025 - декември 2025',
      title: 'Data Science & Risk Analytics Consultant, банков сектор',
      description: [
        'Разработка на прогнозни модели с хоризонт на планиране до пет години и внедряване на стрес тестове.',
        'Пренаписване и рефакториране на наследен R код, оптимизиране на четири бизнес процеса и използване на разработка с помощта на ИИ с човешка проверка за реализацията и документацията.',
        'Изграждане на аналитични работни процеси с R/Shiny и пайплайни за автоматизирано генериране на Excel отчети; превръщане на бизнес изискванията в аналитични решения.'
      ]
    },
    {
      period: 'юни 2025 - юни 2026',
      title: 'Clinical Data Manager, фармация / клинични проучвания',
      description: [
        'Управление на настройката на EDC, дизайна на CRF, автоматичните проверки на данните (edit checks), потребителските роли, спецификациите за трансфер на данни и UAT; координация с CRO, лаборатории и екипи по проучванията.',
        'Изготвяне и преглед на DMP, планове за валидиране, планове за съгласуване на SAE и UAT документация; разработка на базирани на R работни процеси за валидиране и Shiny приложения в среда, обвързана с изискванията на GCP.'
      ]
    },
    {
      period: 'юли 2026',
      title: 'Пайплайн за клинични данни, Dr. Falk Pharma',
      description: [
        'Изграждане на RAW/SDTM/ADaM пайплайн на R с OpenCode и разработка с помощта на ИИ, с валидиране, QC, проследимост и пайплайни за автоматизирани Excel отчети.'
      ]
    },
    {
      period: '2026',
      title: 'Отчетност за одитна следа с помощта на ИИ, Miltenyi Biotec',
      description: [
        'Внедряване на отчети за одитна следа и пайплайни за автоматизирани Excel отчети с OpenCode и разработка с помощта на ИИ, включително логика на отчетите, отстраняване на грешки, документация и човешка проверка.'
      ]
    },
    {
      period: 'от 2019 г.',
      title: 'Управител и съосновател / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Ръководство на консултантската дейност и техническата реализация в здравеопазването, науките за живота, финансите и ИИ, съчетано със собствена практическа разработка, координация на екип и комуникация със заинтересованите страни.',
        'Проектиране на LLM/RAG инфраструктура и интеграция на инструменти на базата на MCP. Въвеждане на работни процеси за R/Python разработка с помощта на OpenCode за генериране на код, рефакториране, тестване и документиране с човешка проверка.'
      ]
    },
    {
      period: 'от 2022 г.',
      title: 'Онкологичен регистър и биобанка, Medical University Pleven',
      description: [
        'Анализ на данни от националния раков регистър и изграждане на Shiny табла за клинични и научни заинтересовани страни; подкрепа за интеграцията, документацията и биобанковите работни процеси за пет вида рак.'
      ]
    },
    {
      period: 'от 2025 г.',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Изграждане на готово за продукционна среда R Shiny приложение; миграция на CSV данни към SQLite и добавяне на администраторско удостоверяване, управление на институции, анализ на посещенията, платени вписвания и форми за запитване с SMTP известия.',
        'Подобряване на адаптивния UI/UX, SEO, структурираните данни и поддръжката на sitemap/robots; добавяне на валидиране на входните данни, екраниране на изхода, ограничаване на опитите за вход и публични записи само след проверка. Проверка на над 400 институции по ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT и AI-on-Demand, с документация за произхода, внедряването и сигурността.'
      ]
    },
    {
      period: 'от 2024 г.',
      title: 'Анализ на финансови новини с LLM, Leap Dynamics (вътрешен проект)',
      description: [
        'Изграждане на работни процеси за периодичен анализ на настроенията с LLM, данни от API, автоматизирани PDF отчети, Streamlit интерфейс, оркестрация с n8n и тестване на работните процеси с помощта на Flowise.'
      ]
    },
    {
      period: '2025',
      title: 'Уъркшопи на ниво висше ръководство, BVMW',
      description: [
        'Провеждане на уъркшопи за участници на ниво управители в мрежата на BVMW.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Научен сътрудник, Humboldt-Universität / Charité, Берлин',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO и съосновател, Promethano GmbH',
      description: [
        'Софтуер и приложения за времеви редове за науките за живота.'
      ]
    }
  ]
};
